<template>
    <div class="list">
      <ul  class="no-bullets">
        <li
          v-for="item in sessions"
          :key="item.id"
          :class="{ active: item.id === currentId }"
          @click="selectSession(item.id)"
        >
          <img class="avatar" width="30" height="30" :src="ExternalFun.getImageUrl(item.user.imgId)" style="display: none;" />
          <p class="name">{{ item.user.name }}</p>
        </li>
      </ul>
    </div>
  </template>
  
  
  <script lang="ts" setup>
  import { useStore } from 'vuex';
  import {onMounted, computed } from 'vue';
  import { ExternalFun } from '../../ExternalFun';
  import { TelegramClient } from "@/websocket/Client";
  // 定义接口 (类型)
  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: any[]; // 可以定义 MessageItem 类型
  }
  
  interface User {
    name: string;
    img: string;
  }
  
  // 使用 Composition API
  const store = useStore();
  const client = TelegramClient.getInstance();
  // 用户信息 (计算属性)
  const user = computed<User>(() => store.state.user);
  
  // 过滤后的会话列表 (计算属性)
  const sessions = computed<Session[]>(() => {
    const filterKey = store.state.filterKey;
    return store.state.sessions.filter((session: Session) =>
      session.user.name.includes(filterKey)
    );
  });

 
  
  // 当前会话 ID (计算属性)
  const currentId = computed<number>(() => store.state.currentSessionId);
  
  // 选择会话的函数
  const selectSession = async(id: number) => {
    console.log("selectSession="+id);
    store.commit('SELECT_SESSION', id);

    let session = store.state.sessions.find((item) => item.id === id);
    if (session) {
       if(session.messages.length > 0) return;
    }
    var senderName = store.state.user.name;
    const result = await client.getPrivateChatDataHistory(senderName, id,5);//必须发两条
    const response = await client.getPrivateChatDataHistory(senderName, id,30);
    let messages = response.messages;
    if(response.recipientPhone == senderName)
    { 
      if(messages && messages.length > 0)
      {
         for (let i = 0; i < messages.length; i++) {
           const element = messages[i];
           var senderId = element.senderId;
           var timestamp = element.timestamp * 1000;
           var content = element.content;
           var isSelf = true;
           if(senderId == id) isSelf = false;
           session.messages.push({
              content: content,
              date: new Date(timestamp),
              self: isSelf,
            });
         }   
      }

    }
 

  };

  const refreshReceiverList = async () => {
    console.log("refreshReceiverList");
    const username = localStorage.getItem("username");
    if (!username) {
      return;
    }
    var senderName = store.state.user.name;
    //const response = await client.getPrivateChatList(username, "session", 1);
    const response = await client.getPrivateChatData(senderName, "session",50);
    var msgList = response.messages;
    if (msgList && msgList.length > 0) {
      let list = msgList.map((receiver: any) => ({
        senderId: receiver.senderId,
        title:receiver.title,
      }));
      let receivers = list.filter((value) => value.senderId != "");
      for (let i = 0; i < receivers.length; i++) {
        const element = receivers[i];
        let session:Session = {
          id:element.senderId,
          user:{name:element.title,imgId:1},
          messages:[]
        };
        store.state.sessions.push(session);

      }
      selectSession(receivers[0].senderId);
      
    }

  }


  // WebSocket 消息监听
  onMounted(() => {
    store.state.sessions = [];
    localStorage.setItem('vue-chat-session', JSON.stringify(store.state.sessions));
    setTimeout(() => {
      refreshReceiverList();
        }, 500);
 
  });


  </script>


  
  <style scoped lang="less">
  .list { 

    height: 510px; /* 设置容器高度，可以根据需要调整 */
    overflow-y: auto; /* 垂直方向滚动 */
    overflow-x: hidden; /* 隐藏水平滚动条 */
     

    li {
      padding: 12px 15px;
      border-bottom: 1px solid #292C33;
      cursor: pointer;
      transition: background-color 0.1s;
  
      &:hover {
        background-color: rgba(255, 255, 255, 0.03);
      }
  
      &.active {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  
    .avatar,
    .name {
      vertical-align: middle;
    }
  
    .avatar {
      border-radius: 2px;
    }
  
    .name {
      display: inline-block;
      margin: 0 0 0 15px;
    }

    .no-bullets {
      list-style-type: none;
      padding-left: 0; /* 移除默认的缩进 */
    }
  }
  </style>